import { c as _c } from "react/compiler-runtime";
export default function Health(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path clipRule="evenodd" d="M36.107 20.313c3.57-.73 7.278-.173 10.495 1.578a16.002 16.002 0 0 1 6.924 7.512c.445.991 1.862.991 2.307 0a16.001 16.001 0 0 1 6.925-7.512 15.446 15.446 0 0 1 10.495-1.578c3.57.73 6.788 2.704 9.103 5.592a16.396 16.396 0 0 1 3.582 10.25c0 10.388-7.236 20.039-14.973 27.355-7.06 6.674-14.343 11.226-16.285 12.393-2.365-1.42-12.617-7.841-20.759-16.989a1 1 0 1 0-1.494 1.33c8.945 10.05 20.325 16.851 21.628 17.614.364.213.833.244 1.245.003 1.075-.63 9.185-5.472 17.039-12.898 7.81-7.386 15.599-17.543 15.599-28.807 0-4.192-1.42-8.256-4.022-11.502-2.602-3.247-6.228-5.475-10.262-6.3a17.447 17.447 0 0 0-11.853 1.78 17.957 17.957 0 0 0-7.121 7.107 17.956 17.956 0 0 0-7.122-7.106 17.446 17.446 0 0 0-11.852-1.782c-4.035.826-7.66 3.054-10.263 6.3a18.396 18.396 0 0 0-4.021 11.503c0 2.61.419 5.16 1.156 7.627a1 1 0 0 0 1.917-.574c-.69-2.302-1.073-4.659-1.073-7.053 0-3.741 1.267-7.364 3.582-10.251 2.314-2.888 5.532-4.862 9.103-5.592zM51.284 64.23L40.954 36.18l-6.35 14.176a1.25 1.25 0 0 1-1.14.74H9.093a1 1 0 1 1 0-2h23.883l6.903-15.414c.458-1.022 1.927-.972 2.314.08l10.288 27.935 4.676-11.812a1.25 1.25 0 0 1 1.162-.79h7.548a1 1 0 1 1 0 2H58.83L53.62 64.26c-.422 1.067-1.939 1.048-2.335-.028z" fill="currentColor" fillRule="evenodd" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden={true} className={className} fill="none" height="96" viewBox="0 0 96 96" width="96" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}